import { preventOrphans } from './textUtils';

/**
 * Funkcja, którą można dodać do punktu wejściowego aplikacji (np. index.js/index.tsx)
 * aby zapobiegać wiszącym spójnikom i przyimkom w całej aplikacji.
 * 
 * @example
 * // W pliku index.js
 * import { noOrphansPlugin } from './utils/noOrphansPlugin';
 * 
 * // Inicjalizacja pluginu
 * noOrphansPlugin();
 * 
 */
export const noOrphansPlugin = () => {
  // Sprawdzamy, czy jesteśmy w środowisku przeglądarki
  if (typeof window === 'undefined' || !window.document || !window.document.body) {
    return;
  }

  const processTextNode = (node) => {
    if (!node || node.nodeType !== Node.TEXT_NODE || !node.textContent || node.textContent.trim() === '') {
      return;
    }

    const parentElement = node.parentElement;
    if (!parentElement) return;

    const skipElements = ['script', 'style', 'textarea', 'code', 'pre', 'input', 'button'];
    if (skipElements.includes(parentElement.tagName.toLowerCase())) {
      return;
    }

    // Przetwarzamy tekst
    const processedText = preventOrphans(node.textContent);
    if (processedText !== node.textContent) {
      const tempElement = document.createElement('span');
      tempElement.innerHTML = processedText;

      const fragment = document.createDocumentFragment();
      while (tempElement.firstChild) {
        fragment.appendChild(tempElement.firstChild);
      }

      parentElement.replaceChild(fragment, node);
    }
  };

  const processNode = (node) => {
    if (!node) return;

    if (node.nodeType === Node.TEXT_NODE) {
      processTextNode(node);
    } 
    else if (node.nodeType === Node.ELEMENT_NODE) {
      Array.from(node.childNodes).forEach(processNode);
    }
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(node => {
          processNode(node);
        });
      }
    });
  });

  processNode(document.body);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  return () => observer.disconnect();
};

export default noOrphansPlugin; 